





































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import type { VueConstructor } from "vue";
import { userModule } from "@/store/modules/user";
import { PPJA_ONLY_HINT } from "@/utility/AsuhanKeperawatanHelper";
import RegisterKunjungan, {
  IfcRegister
} from "@/store/modules/RegisterKunjungan";
import { appModule } from "@/store/modules/app";
import Service from "@/services/AsesmenKeperawatanIntensif";
import Store from "@/store/modules/AsesmenKeperawatanIntensif";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";

import DataAwalSection from "@/components/pemeriksaan/asesmen-intensif/DataAwalSection.vue";
import AirwaySection from "@/components/pemeriksaan/asesmen-intensif/AirwaySection.vue";
import BreathingSection from "@/components/pemeriksaan/asesmen-intensif/BreathingSection.vue";
import CirculationSection from "@/components/pemeriksaan/asesmen-intensif/CirculationSection.vue";
import DisabilitySection from "@/components/pemeriksaan/asesmen-intensif/DisabilitySection.vue";
import ExposureSection from "@/components/pemeriksaan/asesmen-intensif/ExposureSection.vue";
import AlatInvasifSection from "@/components/pemeriksaan/asesmen-intensif/AlatInvasifSection.vue";
import MstSection from "@/components/pemeriksaan/asesmen-intensif/MstSection.vue";
import RisikoJatuhSection from "@/components/pemeriksaan/asesmen-intensif/RisikoJatuhSection.vue";
import RisikoDekubitusSection from "@/components/pemeriksaan/asesmen-intensif/RisikoDekubitusSection.vue";
import SpiritualSection from "@/components/pemeriksaan/asesmen-intensif/SpiritualSection.vue";
import SosialEkonomiSection from "@/components/pemeriksaan/asesmen-intensif/SosialEkonomiSection.vue";
import PolaTidurSection from "@/components/pemeriksaan/asesmen-intensif/PolaTidurSection.vue";
import KebutuhanEdukasiSection from "@/components/pemeriksaan/asesmen-intensif/KebutuhanEdukasiSection.vue";
import DischargePlanningSection from "@/components/pemeriksaan/asesmen-intensif/DischargePlanningSection.vue";
import MasalahKeperawatanSection from "@/components/pemeriksaan/asesmen-intensif/MasalahKeperawatanSection.vue";

interface SectionDef {
  key: string;
  title: string;
  component: VueConstructor;
}

interface AsesmenRaw {
  id?: number;
  content?: Record<string, unknown>;
  examined_at?: string;
  perawat?: { id?: number; nama?: string };
  ppja?: { id?: number; nama?: string };
  dpjp?: { id?: number; nama?: string };
  ppja_verified_at?: string | null;
  dpjp_verified_at?: string | null;
}

interface AsesmenIntensifPayload {
  register_id: number;
  pasien_rm: string;
  unit_id: string;
  type: "intensif";
  version: string;
  content: Record<string, unknown>;
  examined_at: string;
  perawat_user_id: number | string;
  body_map_png?: string;
}

type SectionContent = Record<string, unknown> | unknown[];
type JurnalRanapEntry = IfcRegister["jurnal_ranap"][number];

@Component({
  components: {
    DataAwalSection, AirwaySection, BreathingSection, CirculationSection,
    DisabilitySection, ExposureSection, AlatInvasifSection, MstSection,
    RisikoJatuhSection, RisikoDekubitusSection, SpiritualSection,
    SosialEkonomiSection, PolaTidurSection, KebutuhanEdukasiSection,
    DischargePlanningSection, MasalahKeperawatanSection
  },
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class AsesmenKeperawatanIntensifPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;

  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  content: Record<string, unknown> = {};
  openedPanels: number[] = [0];
  loaded = false;
  saving = false;
  verifyingPpja = false;
  verifyingDpjp = false;
  localLoading = false;
  now = Date.now();
  tickHandle: ReturnType<typeof setInterval> | null = null;

  sections: SectionDef[] = [
    { key: "data_awal", title: "Data Awal Kedatangan", component: DataAwalSection },
    { key: "airway", title: "A — Airway (Jalan Napas)", component: AirwaySection },
    { key: "breathing", title: "B — Breathing (Pernapasan)", component: BreathingSection },
    { key: "circulation", title: "C — Circulation (Sirkulasi)", component: CirculationSection },
    { key: "disability", title: "D — Disability (Neurologis & Nyeri)", component: DisabilitySection },
    { key: "exposure", title: "E — Exposure (Pemeriksaan Fisik)", component: ExposureSection },
    { key: "alat_invasif", title: "Alat Invasif", component: AlatInvasifSection },
    { key: "mst", title: "Skrining Nutrisi (MST)", component: MstSection },
    { key: "risiko_jatuh", title: "Asesmen Risiko Jatuh", component: RisikoJatuhSection },
    { key: "risiko_dekubitus", title: "Asesmen Risiko Dekubitus", component: RisikoDekubitusSection },
    { key: "spiritual", title: "Asesmen Spiritual", component: SpiritualSection },
    { key: "sosial_ekonomi", title: "Status Sosial & Ekonomi", component: SosialEkonomiSection },
    { key: "pola_tidur", title: "Pola Tidur & Kebiasaan", component: PolaTidurSection },
    { key: "kebutuhan_edukasi", title: "Kebutuhan Edukasi", component: KebutuhanEdukasiSection },
    { key: "discharge_planning", title: "Perencanaan Pulang (Discharge Planning)", component: DischargePlanningSection },
    { key: "masalah_keperawatan", title: "Masalah Keperawatan", component: MasalahKeperawatanSection }
  ];

  get loading() {
    return this.localLoading;
  }

  get asesmenRaw(): AsesmenRaw {
    return (Store.asesmen as AsesmenRaw) || {};
  }

  get asesmenId(): number | null {
    return this.asesmenRaw.id ?? null;
  }

  get ppjaVerified(): boolean {
    return !!this.asesmenRaw.ppja_verified_at;
  }

  get dpjpVerified(): boolean {
    return !!this.asesmenRaw.dpjp_verified_at;
  }

  get isLocked(): boolean {
    return (this.ppjaVerified || this.dpjpVerified) && !this.canUpdateSigned;
  }

  get canUpdateSigned(): boolean {
    return userModule.hasPrivilege("asesmen_awal_keperawatan_intensif", "update_signed");
  }

  get canSave(): boolean {
    const action = this.asesmenId ? "edit" : "create";
    return userModule.canAccessForm("asesmen_awal_keperawatan_intensif", action);
  }

  get perawatName(): string {
    if (this.asesmenRaw.perawat?.nama) return this.asesmenRaw.perawat.nama;
    if (!this.asesmenId && userModule.user?.nama) return userModule.user.nama;
    return "-";
  }

  get examinedAtLabel(): string {
    const raw = this.asesmenRaw.examined_at;
    if (!raw) return "Belum disimpan";
    return new Date(raw).toLocaleString("id-ID");
  }

  get masukUnitTs(): number | null {
    const reg: IfcRegister | null = RegisterKunjungan.register;
    if (!reg || !reg.jurnal_ranap || !reg.jurnal_ranap.length) return null;
    const intensifUnits = ["ICU", "ICCU", "HCU", "PICU", "NICU"];
    const jurnal = [...reg.jurnal_ranap]
      .reverse()
      .find((j: JurnalRanapEntry) =>
        intensifUnits.some(u => j.unit?.name?.toUpperCase().includes(u))
      );
    const last = reg.jurnal_ranap[reg.jurnal_ranap.length - 1];
    const tgl = jurnal?.tgl_in || last?.tgl_in;
    const jam = jurnal?.jam_in || last?.jam_in || "00:00";
    if (!tgl) return null;
    const t = new Date(`${tgl}T${jam}:00`).getTime();
    return Number.isFinite(t) ? t : null;
  }

  get countdownText(): string {
    if (!this.masukUnitTs) return "";
    const remainingMs = 60 * 60 * 1000 - (this.now - this.masukUnitTs);
    if (remainingMs <= 0) return `Lewat ${Math.floor(-remainingMs / 60000)} mnt`;
    const min = Math.floor(remainingMs / 60000);
    const sec = Math.floor((remainingMs % 60000) / 1000);
    return `Sisa ${min}:${String(sec).padStart(2, "0")}`;
  }

  get countdownColor(): string {
    if (!this.masukUnitTs) return "grey";
    const remainingMs = 60 * 60 * 1000 - (this.now - this.masukUnitTs);
    if (remainingMs <= 0) return "error";
    if (remainingMs <= 15 * 60 * 1000) return "warning";
    return "primary";
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.loaded = true;
      this.fetchData();
    }
  }

  mounted() {
    this.loadKatalogNyeri();
    this.tickHandle = setInterval(() => {
      this.now = Date.now();
    }, 30000);
    if (!this.loaded) {
      this.loaded = true;
      this.fetchData();
    }
  }

  /**
   * Katalog komponen nyeri (FLACC/NIPS/BPS) dipakai `DisabilitySection`.
   * Halaman induk `PemeriksaanRanap.callDataStore()` sudah memuatnya, jadi
   * ini jaring pengaman — sama seperti `loadKatalogNyeri()` pada Asesmen
   * Awal Keperawatan Ranap Dewasa. Guard `.length` membuatnya idempoten,
   * dan memulainya saat tab dibuka membuat katalog hampir selalu siap
   * sebelum perawat sampai ke panel D (panel akordeon lazy-mount).
   */
  loadKatalogNyeri() {
    if (!storeRefAsesmen.nyeriFLACC.length) storeRefAsesmen.getNyeriFLACC();
    if (!storeRefAsesmen.nyeriNIPS.length) storeRefAsesmen.getNyeriNIPS();
    if (!storeRefAsesmen.nyeriBPS.length) storeRefAsesmen.getNyeriBPS();
  }

  beforeDestroy() {
    if (this.tickHandle) clearInterval(this.tickHandle);
    Store.clear();
  }

  async fetchData() {
    this.localLoading = true;
    try {
      await Store.getByRegister(this.register);
      const raw = this.asesmenRaw && this.asesmenRaw.content;
      if (raw && typeof raw === "object") {
        this.content = JSON.parse(JSON.stringify(raw));
      }
    } catch (e) {
      /* handled via ErrorAlert */
    } finally {
      this.localLoading = false;
    }
  }

  isPanelOpen(i: number): boolean {
    return this.openedPanels.indexOf(i) !== -1;
  }

  contentPart(key: string): SectionContent {
    const val = this.content?.[key];
    if (key === "alat_invasif" || key === "masalah_keperawatan") {
      return Array.isArray(val) ? (val as unknown[]) : [];
    }
    return val && typeof val === "object"
      ? (val as Record<string, unknown>)
      : {};
  }

  updatePart(key: string, val: SectionContent) {
    this.$set(this.content, key, val);
  }

  isSectionFilled(key: string): boolean {
    const v = this.content?.[key];
    if (v == null) return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === "object") {
      const obj = v as Record<string, unknown>;
      return Object.keys(obj).some(k => {
        const vv = obj[k];
        return vv !== null && vv !== "" && vv !== undefined;
      });
    }
    if (typeof v === "string") return v.length > 0;
    return false;
  }

  getUnitId(): string {
    return userModule.user?.unit_id ? String(userModule.user.unit_id) : "";
  }

  nowMysqlString(): string {
    const d = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  async saveRisjatSection(): Promise<void> {
    const refs = (this.$refs as Record<string, unknown>).section_risiko_jatuh;
    const sec = (Array.isArray(refs) ? refs[0] : refs) as
      | { save?: () => Promise<{ id: number; skor: number | null; metode: string; waktu_periksa: string } | null> }
      | undefined;
    if (!sec || typeof sec.save !== "function") return;
    try {
      const saved = await sec.save();
      if (saved?.id) {
        this.$set(this.content, "risiko_jatuh", {
          id: saved.id,
          skor: saved.skor,
          metode: saved.metode,
          waktu_periksa: saved.waktu_periksa
        });
      }
    } catch {
      /* error sudah disurfacing oleh axios interceptor; biarkan page save lanjut */
    }
  }

  async save(finish: boolean) {
    const userId = userModule.user && userModule.user.id;
    if (!userId) {
      appModule.sendErrorAlert("User belum login");
      return;
    }

    // Risiko Jatuh punya tabel sendiri (AsesmenRisikoJatuh) — pakai pattern
    // attach: panggil save() di section sebelum POST content, lalu refleksikan
    // record terbaru ke content.risiko_jatuh sehingga JSON asesmen referensinya
    // sinkron.
    await this.saveRisjatSection();

    const contentForPayload = JSON.parse(JSON.stringify(this.content));
    const exposure = contentForPayload?.exposure;
    const bodyMapPng = exposure?.body_map_png;
    if (exposure) delete exposure.body_map_png;

    const payload: AsesmenIntensifPayload = {
      register_id: Number(this.register),
      pasien_rm: String(this.rm),
      unit_id: this.getUnitId(),
      type: "intensif",
      version: "1.0",
      content: contentForPayload,
      examined_at: this.nowMysqlString(),
      perawat_user_id: userId
    };

    if (typeof bodyMapPng === "string" && bodyMapPng.length > 0) {
      payload.body_map_png = bodyMapPng;
    }

    this.saving = true;
    try {
      if (this.asesmenId) {
        await Service.update(this.asesmenId, payload);
        appModule.NoticeDelay("Berhasil memperbarui asesmen");
      } else {
        await Service.create(payload);
        appModule.NoticeDelay("Berhasil menyimpan asesmen");
      }
      await Store.getByRegister(this.register);
      if (finish) this.openedPanels = [];
    } catch (e) {
      /* handled */
    } finally {
      this.saving = false;
    }
  }

  get canVerifyAsesmenKeperawatan(): boolean {
    return userModule.canVerifyAsesmenKeperawatan;
  }

  get ppjaOnlyHint(): string {
    return PPJA_ONLY_HINT;
  }

  async verifyPpja() {
    const userId = userModule.user && userModule.user.id;
    if (!userId || !this.asesmenId || this.verifikasiTerkunci) return;
    this.verifyingPpja = true;
    try {
      await Service.verifyPpja(this.asesmenId, { ppja_user_id: userId });
      appModule.NoticeDelay("PPJA terverifikasi");
      await Store.getByRegister(this.register);
    } catch (e) {
      /* handled */
    } finally {
      this.verifyingPpja = false;
    }
  }

  async verifyDpjp() {
    const userId = userModule.user && userModule.user.id;
    if (!userId || !this.asesmenId || this.verifikasiTerkunci) return;
    this.verifyingDpjp = true;
    try {
      await Service.verifyDpjp(this.asesmenId, { dpjp_user_id: userId });
      appModule.NoticeDelay("DPJP terverifikasi");
      await Store.getByRegister(this.register);
    } catch (e) {
      /* handled */
    } finally {
      this.verifyingDpjp = false;
    }
  }

  printPdf() {
    if (this.asesmenId) {
      window.open(Service.pdfUrl(this.asesmenId), "_blank");
    }
  }
}
